export const SET_IS_LOADING = 'SET_IS_LOADING'
export const SET_USER = 'SET_USER'
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR'
